import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  FETCH_EMPRESAS,
  FETCH_EMPRESAS_SUCCESS,
  FETCH_EMPRESAS_ERROR,
  SET_EMPRESA_SELECCIONADA,
} from "./actionTypes";

const storedAuth = (() => {
  try {
    return JSON.parse(localStorage.getItem("authUser"));
  } catch {
    return null;
  }
})();

const storedEmpresa = (() => {
  try {
    return JSON.parse(localStorage.getItem("empresaSeleccionada"));
  } catch {
    return null;
  }
})();

const initialState = {
  error: "",
  loading: false,
  user: storedAuth?.usuario || null,
  accessToken: storedAuth?.accessToken || null,
  refreshToken: storedAuth?.refreshToken || null,
  empresas: [],
  empresasLoading: false,
  empresasError: "",
  empresaSeleccionada: storedEmpresa || null,
  isUserLogout: false,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return { ...state, loading: true, error: "", empresas: [], empresaSeleccionada: null };
    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.usuario,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        isUserLogout: false,
        error: "",
      };
    case FETCH_EMPRESAS:
      return { ...state, empresasLoading: true, empresasError: "" };
    case FETCH_EMPRESAS_SUCCESS:
      return { ...state, empresasLoading: false, empresas: action.payload };
    case FETCH_EMPRESAS_ERROR:
      return { ...state, empresasLoading: false, empresasError: action.payload };
    case SET_EMPRESA_SELECCIONADA:
      return { ...state, empresaSeleccionada: action.payload.empresa };
    case LOGOUT_USER:
      return { ...state };
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        isUserLogout: true,
        user: null,
        accessToken: null,
        refreshToken: null,
        empresas: [],
        empresaSeleccionada: null,
      };
    case API_ERROR:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};

export default login;